module.exports = __webpack_public_path__ + "img/11_Kombipaket-Tabelle.908c80d0.svg";